<script>

import Matter from 'matter-js'
import Mixin from '@/mixins/Experience'

export default {

    name: 'Champagne',
    mixins: [ Mixin ],
    render: h => h(), 

    beforeDestroy() { this.removeAllBulle()
    },

    created() {

        this.$bulles = []
        this.$loops = { 0: 0, 1: 0 }
        this.$id = 0
        this.$rayon = 80
        this.$world.gravity.y = -0.4
    },

    mounted() {

        TweenMax.to(this.$parent.$black, 0.5, { alpha: 1 })
        this.addBackground('champagne')
    },

    methods: {

        click() {

            this.addBulles()
            this.$tween = TweenMax.delayedCall(0.7, this.click)
        },

        addElements() {

            let graphics = new PIXI.Graphics()
                graphics.beginFill(0xfcab9a, 1)
                graphics.drawRect(0, 0, this.$width, this.$height)
                graphics.endFill()

            const texture = graphics.generateCanvasTexture()
            this.$beige = new PIXI.Sprite(texture)
            this.$beige.alpha = 0.1
            this.$foreground.addChild(this.$beige)
            this.$sprites_foreground.push(this.$beige)

            const els = [

                { id: 'top_left', x:0, y: 0, ax: 0, ay: 0 },
                { id: 'black_left', x:0, y: 1500, ax: 0, ay: 0.5 },
                { id: 'gold_left', x:280, y: 1920, ax: 0.5, ay: 1 },
                { id: 'gold_right', x:1080, y: 660, ax: 1, ay: 0.5 },
                { id: 'tagline_1', x:210, y: 1360, ax: 0.5, ay: 0.5 },
                { id: 'tagline_2', x:246, y: 1534, ax: 0.5, ay: 0.5 },
                { id: 'tagline_3', x:276, y: 1758, ax: 0.5, ay: 0.5 },
                { id: 'legal', x:0, y: 0, ax: 0, ay: 0 },
            ]

            _.each(els, (el)=>{ this['$'+ el.id] = this.getSprite(el) })
            this.showElements()
        },

        showElements() {

            this.$tempo = 0.45
            this.$tween = new TimelineMax({ delay: 0.5 })
            .add([
                TweenMax.from(this.$top_left, 1.0, { x:-250*this.$coef, y:-250*this.$coef, rotation: 1, ease: Expo.easeOut }),
                TweenMax.from(this.$black_left, 1.0, { x:-350*this.$coef, ease: Expo.easeOut, rotation: 1, delay: this.$tempo }),
                TweenMax.from(this.$gold_left, 1.0, { y:2400*this.$coef, ease: Expo.easeOut, rotation: -1, delay: this.$tempo*2 }),
                TweenMax.from(this.$gold_right, 1.0, { x:1400*this.$coef, ease: Expo.easeOut, rotation: 1, delay: this.$tempo*3, onComplete: ()=>{ this.click() } }),
                TweenMax.from(this.$tagline_1, 1.4, { y:2400, delay: this.$tempo*4, ease: Expo.easeOut }),
                TweenMax.from(this.$tagline_2, 1.5, { y:2400, delay: this.$tempo*4.4, ease: Expo.easeOut }),
                TweenMax.from(this.$tagline_3, 1.8, { y:2400, delay: this.$tempo*4.8, ease: Expo.easeOut }),
                TweenMax.from(this.$legal, 1.0, { alpha: 0, delay: this.$tempo*6, onComplete: ()=>{
                    this.$parent.resetRecord(8)
                }, ease: Linear.easeNone }),
                TweenMax.to(this.$parent.$black, 0.5, { alpha: 0, ease: Linear.easeNone, delay: this.$tempo*6 }),
            ])        
        },

        getSprite(data) {

            const sp = data.id.split('_')
            const id = (sp[0] == 'tagline' && sp.length>1) ? ('tagline/'+ sp[1])  : data.id

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/champagne/'+ id +'.png')))
                sprite.anchor.x = data.ax
                sprite.anchor.y = data.ay
                sprite.position.set(data.x*this.$coef, data.y*this.$coef)
                sprite.scale.set(1*this.$coef, 1*this.$coef)
            this.$foreground.addChild(sprite)
            this.$sprites_foreground.push(sprite)
            return sprite
        },

        addBackground(arg) {

            let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/champagne/bkg.png')))
                sprite.anchor.x = 0.5
                sprite.anchor.y = 0.5
                sprite.position.set(this.$width/2, this.$height/2)
                sprite.scale.set(1*this.$coef, 1*this.$coef)
            this.$background.addChild(sprite)
            this.$sprites_background.push(sprite)
            this.$bkg = sprite
            this.$tween = TweenMax.from(this.$bkg, 0.50, { alpha: 0, ease:Linear.easeNone, delay: 0.5, onComplete: this.backgroundCompleted })
        },

        backgroundCompleted() { this.addElements()
        },

        updateBulle(bulle) {
            if(bulle.alive) {
                bulle.sprite.position.x = bulle.body.position.x
                bulle.sprite.position.y = bulle.body.position.y
                if(bulle.sprite.position.y <= -10) 
                    this.removeBulle(bulle)
            }
        },

        removeBulle(bulle) {
            bulle.alive = false
            this.$World.remove(this.$world, [ bulle.body ])
            this.$champagne.removeChild(bulle.sprite)
        },

        removeAllBulle() { 

            _.each(this.$bulles, (bulle)=>{ this.removeBulle(bulle) })
        },

        addBulles() {

            const nb = _.random(8, 12)/this.$coef
            for(var i=0; i< nb; i++) {

                const size = _.random(8, 20)
                const px = _.random((this.$width/2)-120, (this.$width/2)+120) 
                const py = _.random(this.$height + 10, this.$height + 200)
                const ratio = (size/14)*this.$coef
                const bulle = this.$Bodies.circle(px, py, size)
                
                this.$World.add(this.$world, [ bulle ])
                if(this.$parent.$debug) return

                const bl = _.random(1,3)
                let sprite = new PIXI.Sprite(new PIXI.Texture.fromImage(require('@/assets/bulle/bulle_'+ bl +'.png')))
                    sprite.anchor.x = 0.5
                    sprite.anchor.y = 0.5
                    sprite.position.set(px, py)
                    sprite.scale.set(ratio, ratio)
                    sprite.rotation = (Math.PI/_.random(0, 20))
                this.$champagne.addChild(sprite)
                let obj = {
                    id: this.$id,
                    alive: true,
                    body : bulle,
                    sprite: sprite
                }
                this.$bulles.push(obj)
                this.$id += 1
            }
        },

        animate() {

           if(this.$bulles.length > 0) {
                _.each(this.$bulles, (bulle)=>{ this.updateBulle(bulle) })
            }
        },
    }
}
</script>